<template>
  <div id="List2" class="scroller-wrapper scroll-vertical">
    <div id="Scroller">
<!--      <div id="BannerContainer" @click="BannerClick()"-->
<!--           v-if="Banners.length>0">-->
<!--        <transition :enter-active-class="'slideIn'+BannerInDirecter"-->
<!--                    :leave-active-class="'slideOut'+BannerOutDirecter">-->
<!--          <img @touchstart="BannerTouchStart($event)"-->
<!--               @touchend="BannerTouchEnd($event)"-->
<!--               :key="thisBanner"-->
<!--               class="animated"-->
<!--               :src="require('../../assets/1st/Articles/Article_'+Banners[thisBanner-1]+'/lunbo.jpg')">-->
<!--        </transition>-->
<!--        <div id="BannerPointContainer" v-if="Banners.length>1"-->
<!--             :style="BannerPointContainerStyle">-->
<!--          <div v-for="p in Banners.length" class="BannerPoint" :class="{BannerPointSelect:thisBanner==p}"></div>-->
<!--        </div>-->
<!--      </div>-->
      <div id="BannerContainer">
          <img src="../../assets/1st/article_type2_top_img.jpg">
      </div>
      <div id="ArticleContainer">
        <div class="ArticleBar" @click="viewArticle(a)"
             v-for="a in ThisList">
          <div class="ArticleIMG">
            <img :src="require('../../assets/1st/Articles/Article_'+a+'/cover.jpg')">
          </div>
          <div class="ArticleTitle">
            {{AllList[a].title}}
          </div>
          <div class="ArticleDate">
            {{AllList[a].date}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../store/1st';
  export default {
    name: "List2",
    store,
    data(){
      return {
        scroller:0,
        AllList:[],
        Banners:[],
        touchVal:{x:0,y:0},
        BannerInDirecter:"Right",
        BannerOutDirecter:"Left",
        thisBanner:1,
        ThisList:[]
      }
    },
    mounted() {
      this.SetBannerPlay();
      this.AllList=this.$store.state.ArticleList
      this.ThisList=this.$store.state.List2
      var scrollerConfig = {
        '//Description' : 'Default scroller with no configuration'
      };

      this.scroller = new Scroller('#List2', scrollerConfig);
      this.Banners=this.$store.state.Banner2;
    },
    methods:{
      SetBannerPlay:function(){
        this.IntervalID=setInterval(()=> {
          this.NextBaner();
        },3000)
      },
      NextBaner:function(){
        this.BannerInDirecter="Right";
        this.BannerOutDirecter="Left";
        if(this.thisBanner==this.Banners.length) this.thisBanner=1;
        else this.thisBanner++
      },
      PreBaner:function(){
        this.BannerInDirecter="Left";
        this.BannerOutDirecter="Right";
        if(this.thisBanner==1) this.thisBanner=this.Banners.length;
        else this.thisBanner--
      },
      BannerTouchStart:function (e) {
        this.touchVal.x=e.touches[0].clientX
      },
      BannerTouchEnd:function (e) {
        let limit=this.$store.state.WindowSize.WindowWidth*0.15;
        if(e.changedTouches[0].clientX-this.touchVal.x>limit){
          clearInterval(this.IntervalID)
          this.PreBaner()
          this.SetBannerPlay()
        }
        if(e.changedTouches[0].clientX-this.touchVal.x<(-1*limit)){
          clearInterval(this.IntervalID)
          this.NextBaner()
          this.SetBannerPlay()
        }
      },
      viewArticle(id){
        this.$store.commit('PushArticle',id);
        this.$router.replace("/Article/"+id)
      },
      BannerClick(){
        let id=this.Banners[this.thisBanner-1]
        this.viewArticle(id);
      }
    },
    computed:{
      BannerPointContainerStyle(){
        return {
          width: 4.2*this.Banners.length+'rem',
          left:(112.5-(4.2*this.Banners.length))/2+'rem'
        }
      }
    }
  }
</script>

<style scoped>
  #List2{
    width: 100%;
    height: 100%;
    background: #f7f7f7;
  }
  #Scroller{
    width: 100%;
  }
  #BannerContainer{
    position: relative;
    width: 112.5rem;
    height: 63.4rem;
    overflow: hidden;
  }
  #BannerContainer img{
    position: absolute;
    width: 112.5rem;
  }
  #BannerPointContainer{
    position: absolute;
    height: 4.2rem;
    top:57.2rem;
  }
  .BannerPoint{
    width: 2rem;
    height: 2rem;
    border-radius: 1rem;
    margin: 1.1rem;
    background: #4136ff;
  }
  .BannerPointSelect{
    background: #ffffff;
  }

  #ArticleContainer{
    padding:2.8rem ;
    padding-bottom: 15rem;
  }
  .ArticleBar{
    width: 50rem;
    /*height: 56rem;*/
    height: 61.4rem;
    margin: 1.7rem;
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
    /*margin-top: 4.9rem;*/
    /*margin-bottom: 4.9rem;*/
    background: #fff;
    border-radius: 4.5rem;
    overflow: hidden;
    box-shadow: 0rem 0rem 2rem 0.1rem #ccc;
  }
  .ArticleIMG{
    width: 100%;
    height: 39rem;
    /*height: 56rem;*/
    overflow: hidden;
  }
  .ArticleIMG img{
    width: 100%;
  }
  .ArticleTitle{
    width: 41rem;
    height: 14.7rem;
    /*height: 9.4rem;*/
    /*height: 0rem;*/
    line-height: 4.7rem;
    /*font-size: 3.3rem;*/
    font-size: 3.5rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 2rem;
  }
  .ArticleDate{
    width: 66.4rem;
    height: 2.3rem;
    /*height: 0rem;*/
    line-height: 2.3rem;
    font-size: 2.3rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 2.3rem;
    color: #989898;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/List2.vue